import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";

const AllotingVehicleTable = ({ myvehicleList, handleAllot, tab }) => {

  return (
    <TableContainer>
      {myvehicleList?.length ? (
        <Table aria-label="simple table" className="allridesTableMain">
          <TableHead>
            <TableRow>
              <TableCell>Model</TableCell>
              <TableCell>Vehicle No.</TableCell>
              <TableCell>Vehicle Group</TableCell>
              <TableCell>Driver</TableCell>
              <TableCell>Availability</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {myvehicleList?.length > 0 &&
              myvehicleList?.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell>
                    {data?.Vehicle?.carModel || "NA"}
                  </TableCell>
                  <TableCell>
                    {data?.Vehicle?.regNumber || "NA"}
                  </TableCell>
                  <TableCell>
                    {data?.Vehicle?.MasterCarType?.carType ||
                      "NA"}
                  </TableCell>
                  <TableCell>{data?.driverName || "NA"}</TableCell>
                  <TableCell>
                    <Typography
                      className={data?.isOnDuty ? "colorGreen" : "colorRed"}
                      variant="caption"
                      sx={{ fontSize: '14px' }}
                    >
                      {data?.isOnDuty ? "On Duty" : "Off Duty"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <CommonButton
                      name="Allot"
                      btnClass={"btnXtraSmall btnBlue"}
                      onClick={() => handleAllot(data)}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      ) : (
        <Box>
          <CommonNoDataFound />
        </Box>
      )}
    </TableContainer>
  );
};

export default AllotingVehicleTable;
